import React, { useState } from "react";
import { Button, Check, Edit01, TextInput, XClose } from "@opendate-app/setlist";

const styles = {
  row: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    minWidth: 0,
  },
  input: {
    flex: "1 1 240px",
    maxWidth: 400,
  },
};

const InlineEditField = ({ label, value, fieldName, onChange, onSave, onCancel }) => {
  const [isEditing, setIsEditing] = useState(false);

  if (isEditing) {
    return (
      <form
        style={styles.row}
        onSubmit={(e) => {
          e.preventDefault();
          setIsEditing(false);
          onSave();
        }}
      >
        {label}
        <div style={styles.input}>
          <TextInput
            size="sm"
            autoFocus
            aria-label={fieldName}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
        <Button type="submit" variant="tertiary" size="xs" icon={Check} aria-label={`Save ${fieldName}`} />
        <Button
          variant="tertiary"
          size="xs"
          icon={XClose}
          aria-label={`Cancel editing ${fieldName}`}
          onClick={() => {
            setIsEditing(false);
            onCancel();
          }}
        />
      </form>
    );
  }

  return (
    <div style={styles.row}>
      {label}
      <span>{value}</span>
      <Button variant="tertiary" size="xs" icon={Edit01} aria-label={`Edit ${fieldName}`} onClick={() => setIsEditing(true)} />
    </div>
  );
};

export default InlineEditField;
